import Script from "next/script";

export default function FlowbiteScript() {
  return (
    <Script src="https://unpkg.com/flowbite@1.5.1/dist/flowbite.js"></Script>
  );
}
